import type { Option } from '@/modules/common/types/option.type.ts';
import { Conjunction } from '@/modules/common/enums/conjunction.enum.ts';

export const CONJUNCTIONS: Option<Conjunction>[] = [
  { label: 'viewer.conjunction.and', code: Conjunction.And },
  { label: 'viewer.conjunction.or', code: Conjunction.Or },
];
